// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fKaS","colBig":"styles_colBig__2cy_M","colSmall":"styles_colSmall__2z3ea"};